import React from "react";
import { Field } from "redux-form";
import buildFormField from "./buildFormField";
import memoize from "fast-memoize";
import { useCallback } from "react";
import DropDownInput from "./DropDownInput";

const FormField = buildFormField(DropDownInput, (input, meta, rest) => ({
  ...input,
  invalid: meta.touched && meta.invalid,
  onChange: useCallback((_, data) => input.onChange(data.value)),
  onBlur: undefined,
  ...rest,
}));

const buildValidator = memoize((required, other) => {
  return [(value) => (required && !value ? "required" : undefined)].concat(
    other || []
  );
});

export default function DropDownField(props) {
  return (
    <Field
      {...props}
      component={FormField}
      validate={buildValidator(props.required, props.validate)}
    />
  );
}
